import omitUndefinedProps from '../../utils/omitUndefinedProps';

export const toApiModel = ({ id, content, value, src, imageId }) =>
  omitUndefinedProps({
    id,
    content,
    value,
    src,
    image_id: imageId,
  });

export const toAppModel = ({ id, content, value, src }) =>
  // We intentionally omit `image_id` coz it's never used on frontend @sinslav
  omitUndefinedProps({
    id,
    content,
    value,
    src,
  });
